// src/components/Layout.js
import React from 'react';
import Navbar from './Navbar';
import '../../styles/Layout.css';

function Layout({ children }) {
  return (
    <div className="layout-container">
      <div className="safe-area-top"></div>
      <Navbar />
      <main>{children}</main>
    </div>
  );
}

export default Layout;
